import React, {useEffect} from 'react'
import { makeStyles } from '@mui/styles';
import { Grid, Typography } from '@mui/material'
import Busy from "../../components/Busy";
import { accountRegistrationEndpoints } from '../../requests/api-endpoints'
import useUrlQueryParams from "../../hooks/useUrlQueryParams";
import {toast} from 'react-toastify';
import { withRouter } from '../../hooks/withRouter';
import { VerifyToken, TokenVerificationResult } from '../../util/TokenVerification'

const useStyles: () => {
  tokenVerificationParent: CSSStyleSheet,
  tokenVerificationContainer: CSSStyleSheet,
  tokenIcon: CSSStyleSheet,
  tokenMessage: CSSStyleSheet,
} = makeStyles(() => ({
  tokenVerificationParent: {
    alignItems:"center",
    justifyContent:"center",
  },
  tokenVerificationContainer: {
    background: '#FFFFFF',
    boxShadow: '0px .57em .58em -.4em rgba(0, 0, 0, 0.2), 0px 1.1em 1.7em 2px rgba(0, 0, 0, 0.14), 0px .4em 2em .4em rgba(0, 0, 0, 0.12)',
    borderRadius: '0.6em',
    width: '32.57em',
    padding: '3.78em 3.78em 1em 3.78em',
    transform: 'translateY(-40%)',
    alignContent: 'center',
    textAlign:"center"
  },
  tokenMessage: {
    fontFamily: 'Inter',
    fontWeight: '400 !important',
    fontSize: '1.71em !important',
    lineHeight: '133.4%',
    color: '#000000',
    marginBottom: '0.4em !important',
  },
}));

const EmailVerification = ({history}) => {
  const { token } = useUrlQueryParams();
  const classes = useStyles();

  const handleResponse = (response) => {
    if (response?.status === TokenVerificationResult.VALID) {
      toast.success(response?.message || 'Email Successfully Verified.');
    } else {
      toast.error(response?.message || 'An error occurred while verifying your email. Please try again later.');
    }
    Busy.set(false);
    history('/login');
  }

  useEffect(() => {
    Busy.set(true);
    const timeout = setTimeout(() => {
      VerifyToken(token, accountRegistrationEndpoints.verifyEmail, handleResponse);
    }, 100);
    return () => {
      clearTimeout(timeout);
      Busy.set(false);
    }

  }, []);

  return (
    <section>
      <Grid container className={classes.tokenVerificationParent} sx={{ minHeight: '70vh' }} mt={10} mb={-200} >
        <Grid className={classes.tokenVerificationContainer} >
          <Typography className={classes.tokenMessage}>Verifying Your Email</Typography>
        </Grid>
      </Grid>
    </section>
  )
}

export default withRouter(EmailVerification)